import React, { useEffect, useState, Fragment } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormControl,
  InputGroup,
  OverlayTrigger,
  Row,
  Toast,
  Tooltip
} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import {FaSearch} from 'react-icons/fa'
import { formato_monto } from '../../common/Formatos'
import { obtenerDatosGrilla } from '../../store/actions/reasignar-responsable-action'
import { LoadingComponent } from 'recupero-comunes'


const Reasignar = ({formik,setIsExtra,isExtra,setIsJudi,isJudi}) => {
  const [loading, setLoading]=useState(false)
  const [isAutomatico, setIsAutomatico]=useState(true)
  const [zona, setZona]=useState('true')
   const data_reasignar = useSelector((state) => state.ReasignarResponsableReducer)
   const { cfg_form28, comboZonas,datosGestionCaso} = data_reasignar
   const data_recepciona = useSelector((state) => state.casoGeneralReducer)
   const { llaves} = data_recepciona
   const dispatch=useDispatch()
   useEffect(()=>{
    if(llaves && datosGestionCaso ){
      setLoading(true)
      let query = Buffer.from(JSON.stringify({
      "zona":datosGestionCaso && datosGestionCaso.datosGestionCaso[0]['codZona'],
      "idCaso": llaves && llaves['idCaso'],
      })).toString('base64')
      dispatch(obtenerDatosGrilla(query)).then(()=>setZona(datosGestionCaso && datosGestionCaso.datosGestionCaso[0]['codZona']))
    .then(()=>{
      setLoading(false)
    })
    }

   },[datosGestionCaso])
  return (
    <>
 <style type='text/css'>
      
    </style>
      <LoadingComponent show={loading}/>
        <Card >
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            {cfg_form28
              ?`${ cfg_form28.cfg_form28['reasignaresponsable-title-reasigna']} ${llaves && llaves['idCaso']}`
              : ''} 
          </Card.Header>
          <Container>
           
            
              {cfg_form28? (
                <div >
                  
                  <Row >
                 
                    <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form28.cfg_form28[
                            'reasignaresponsable-cmb-zona'
                          ]+" *"
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Select
                        className='mt-2'
                        aria-label='Default select example' 
                                disabled={isAutomatico}           
                        onChange={(e) => {
                          setLoading(true)
                          setZona(e.target.value)
                         
                            let query = Buffer.from(JSON.stringify({
                                "zona":e.target.value,
                                "idCaso": llaves && llaves['idCaso'],
                            })).toString('base64')
                            dispatch(obtenerDatosGrilla(query))
                            .then(()=>{setLoading(false)})
                 
                        }}
                        name='zonas'
                        value={zona}
                         //value={formik.values.modoAsignacion = zona}
                        // error={formik.errors.zonas}
                      >
                        <option value={''}>Seleccione...</option>
                        {comboZonas &&
                          comboZonas.comboZonas?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                      </Form.Select>
                    </Col>
                    <Col md='3'>
                      <Form.Label
                       className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form28.cfg_form28[
                            'reasignaresponsable-chek-modselec'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Check className='mt-2' type='checkbox' label={
                          cfg_form28.cfg_form28[
                            'reasignaresponsable-chek-label'
                          ]
                        } style={{ fontSize:'16px', fontWeight:'bold'}} 
                        checked={isAutomatico}
                        onChange={()=>setIsAutomatico(!isAutomatico)}
                        />
                   </Col>
                    
                  
               </Row>
               <Row >
                 
                 <Col md='7'>
                   
                 </Col>
                 <Col md='5' className='d-flex'>
                 <hr style={{ color: 'gray', height: '2px', marginTop:'60px', width:'100px'}}></hr>
                 <div style={{width:'200px', marginLeft:'15px'}}>

                   <Form.Label
                    
                     style={{ fontWeight: 'bold', fontSize: '16px', marginTop:'45px' }}
                   >
                     {
                       cfg_form28.cfg_form28[
                         'reasignaresponsable-lbl-ultdocemeses'
                       ]
                     }
                   </Form.Label>
                 </div>
                 <div style={{ marginLeft:'15px'}}>

                   <Form.Check type='checkbox' label={
                          cfg_form28.cfg_form28[
                            'reasignaresponsable-chek-judicial'
                          ]
                        } style={{ marginTop:'45px', fontSize:'16px', fontWeight:'bold' }} 
                        
                        onChange={()=>setIsJudi(!isJudi)}
                        />
                 </div>
                 <div style={{ marginLeft:'15px'}} >

                   <Form.Check type='checkbox' label={
                          cfg_form28.cfg_form28[
                            'reasignaresponsable-chek-estrajudi'
                          ]
                        } style={{ marginTop:'45px', fontSize:'16px', fontWeight:'bold'}}
                        onChange={()=>setIsExtra(!isExtra)}
                        />
                 </div>
                 <hr style={{ color: 'gray', height: '2px', marginTop:'60px', width:'100px',marginLeft:'15px'}}></hr>
                   
                </Col>
                <Col >
                
                </Col>
                 
                <Col md='3'>
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form28.cfg_form28[
                         'consultaantecjudicial-lbl-fechacausa'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                   {/* {datosAntecedentes && datosAntecedentes.datosAntecedentes[0]!==undefined &&
                        datosAntecedentes.datosAntecedentes[0]['fecIngresaCausaFormat'] !== undefined &&
                        datosAntecedentes.datosAntecedentes[0]['fecIngresaCausaFormat'] !== null &&
                        datosAntecedentes.datosAntecedentes[0]['fecIngresaCausaFormat'] !== ''
                        ? datosAntecedentes.datosAntecedentes[0]['fecIngresaCausaFormat']
                        : ''} */}
             </Form.Text>
                  
                 </Col>  
                <Col md='3'>
                   <Form.Label
                    className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form28.cfg_form28[
                         'consultasoldescuento-lbl-mtorecobro'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                   {/* {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                     datosSolicitud.datosSolicitud[0]['montoRecobro'] !== undefined &&
                     datosSolicitud.datosSolicitud[0]['montoRecobro'] !== null &&
                     datosSolicitud.datosSolicitud[0]['montoRecobro'] !== ''
                     ? formato_monto(datosSolicitud.datosSolicitud[0]['montoRecobro'])
                     : ''} */}
             </Form.Text>
                  
                 </Col>  
                               
                  
             
            </Row>
               
              
             
           
           
          
            
                    </div>
              ) : null}
             
           
          
     
      
   
          </Container>
        </Card>
     
     
    
    </>
  )
}

export default Reasignar
